import type { ReactNode } from 'react'

interface BusyLabelProps {
  busy: boolean
  label: ReactNode
  busyLabel: ReactNode
}

/**
 * Button content that keeps the action label visible while a teal spinner
 * marks the request. Used by login, registration and the terms/update gates.
 */
export function BusyLabel({ busy, label, busyLabel }: BusyLabelProps) {
  if (!busy) return <>{label}</>
  return (
    <>
      <span className="spinner spinner--sm" aria-hidden="true" />
      <span>{busyLabel}</span>
    </>
  )
}
